import { BuyButton } from "./BuyButton";
import { PRICE_LABEL } from "@/lib/checkout";

export const StickyBar = () => (
    <div
        data-testid="mobile-sticky-buy-bar"
        className="fixed inset-x-0 bottom-0 z-50 border-t border-slate-200/80 bg-white/90 px-4 py-2.5 backdrop-blur-xl md:hidden"
    >
        <div className="mx-auto max-w-6xl">
            <BuyButton
                testId="mobile-sticky-buy-btn"
                label={`${PRICE_LABEL} · Ottieni le 3 simulazioni`}
                className="w-full !py-3 text-sm"
            />
        </div>
    </div>
);
